import client from '../../config/api';
import {
  LOCAL_SET_CURRENT_USER,
  LOCAL_SET_USERS,
  LOCAL_SET_USERS_PENDING_APPROVAL,
  LOCAL_SET_USERS_LOGGED_IN_TODAY,
  LOCAL_SET_USERS_REJECTED,
  LOCAL_SET_USERS_WITHOUT_SEPIA_INFO,
} from './mutations/mutationTypes';

function handleError(error) {
  throw error;
}

export default {
  async USERS_GET_CURRENT({ commit }) {
    try {
      const result = await client.get('/users/current');
      commit(LOCAL_SET_CURRENT_USER, result.data);
      commit('SET_CURRENT_USER', result.data, { root: true }); // We still have the current user not refactored on root state
      return result.data;
    } catch (error) {
      console.warn(error);
      handleError(error);
    }
  },

  /**
   * Get the list of users to show on admin's page
   */
  async GET_USERS({ commit }, query) {
    const { data } = await client.get('/users', {
      params: {
        ...query,
      },
    });
    commit(LOCAL_SET_USERS, data);
    return data;
  },

  /**
   * Get the list of users pending approval
   */
  async GET_USERS_PENDING_APPROVAL({ commit }, query) {
    const queryWithPendingApproval = { pendingApproval: true, ...query };
    const result = await client.get('/users', {
      params: {
        ...queryWithPendingApproval,
      },
    });
    commit(LOCAL_SET_USERS_PENDING_APPROVAL, result.data);
  },

  async GET_USERS_LOGGED_IN_TODAY({ commit }, query) {
    const now = new Date();
    const lastMidnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const queryWithLoggedInToday = {
      loggedInAfter: lastMidnight.getTime(),
      ...query,
    };
    const result = await client.get('/users', {
      params: {
        ...queryWithLoggedInToday,
      },
    });
    commit(LOCAL_SET_USERS_LOGGED_IN_TODAY, result.data);
  },

  async GET_USERS_REJECTED({ commit }, query) {
    const queryWithRejected = { rejected: true, ...query };
    const result = await client.get('/users', {
      params: {
        ...queryWithRejected,
      },
    });
    commit(LOCAL_SET_USERS_REJECTED, result.data);
  },

  async GET_USERS_WITHOUT_SEPIA_INFO({ commit }, query) {
    const queryWithNoSepiaInfo = { noSepiaInfo: true, ...query };
    const result = await client.get('/users', {
      params: {
        ...queryWithNoSepiaInfo,
      },
    });
    commit(LOCAL_SET_USERS_WITHOUT_SEPIA_INFO, result.data);
  },
};
